import { Text, View, Image } from "@react-pdf/renderer";

export function Footer({
  styles,
  clearLogo,
}: {
  styles: any;
  clearLogo: string;
}) {
  return (
    <View style={styles.footer} fixed>
      <Image
        style={styles.footerImage}
        src={{
          body: "",
          headers: {},
          method: "GET",
          uri: clearLogo,
        }}
      />

      <Text style={styles.footerText}>www.clearhealthinc.com</Text>
      <Text style={styles.footerText}>
        888-918-2522 | support@clearhealthinc.com
      </Text>
      <Text style={styles.footerText}>
        Clear Health Inc. All rights reserved.
      </Text>
    </View>
  );
}
